import { render } from "./rightPart.vue?vue&type=template&id=4fe10c18&scoped=true"
import script from "./rightPart.vue?vue&type=script&lang=js"
export * from "./rightPart.vue?vue&type=script&lang=js"

import "./rightPart.vue?vue&type=style&index=0&id=4fe10c18&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe10c18"]])

export default __exports__